export class Breakpoints {
  static tabletLgBreakpoint = '(min-width: 1024px)';
  static tabletBreakpoint = '(min-width: 768px)';
  static mediumPhones = '(min-width: 560px)';
}
